import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {DocumentModel} from '../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {PersistDocumentService} from './persist-document.service';
import {AddTransportPage} from '../modals/add-transport/add-transport.page';
import {GeneralService} from './general.service';
import {StateManagerService} from './state-manager.service';
import {ConfigurationModel} from '../models/configuration.model';
import {CollectionsNames} from '../definitions/collections-names';

@Injectable({
    providedIn: 'root'
})
export class CheckTransportAddedService {

    private transports: DetaillineDTOModel[];

    constructor(private loki: LokijsService,
                private alertController: AlertController,
                private persistDocService: PersistDocumentService,
                private modalController: ModalController,
                private generalServices: GeneralService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames) {
    }

    isTransportAdded(doc: DocumentModel): boolean {
        const configuration = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION) as ConfigurationModel;
        console.log(configuration);
        if (!configuration.suggestAddTransportFee) {
            return false;
        }
        // Checks if there's transports registered
        this.transports = this.loki.getCollection('producttype')
            .chain()
            .find({transportProductType: true})
            .data();
        console.log(this.transports);
        if (this.transports.length === 0) {
            return true;
        }

        // Will iterate the detail lines looking for transport
        // if found will return true and the user will not be prompted to add a transport.
        for (const detail of doc.detailLines) {
            for (const transp of this.transports) {
                if (detail.plu === transp.plu) {
                    return true;
                }
            }
        }

        return false;
    }

    async addTransport(doc: DocumentModel) {
        const alert = await this.alertController.create({
            message: 'Do you want to add Transport fee?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.persistDocument(doc);
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.openModal(doc);
                    }
                }
            ]
        });
        await alert.present();
    }

    async openModal(doc: DocumentModel) {
        const modal = await this.modalController.create({
            component: AddTransportPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': doc
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            this.persistDocument(doc);
        });

        return await modal.present();
    }

    private persistDocument(doc: DocumentModel) {
        this.persistDocService.persistDocument(doc);
        this.generalServices.createToast('Contract Saved!');
        this.modalController.dismiss();
    }
}
